// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { TournamentFragmentDoc } from '../../fragments/__generated__/TournamentFragment';
export type CasinoTournamentsPublicTournamentsQueryOrderBy = {
  closeAt?: number | null | undefined;
  openAt?: number | null | undefined;
};

export type TournamentsQueryVariables = Exact<{
  site?: string | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  onlyCurrent?: boolean | null | undefined;
  onlyFuture?: boolean | null | undefined;
  onlyPast?: boolean | null | undefined;
  onlyMy?: boolean | null | undefined;
  onlyMyWithUnclaimedPrize?: boolean | null | undefined;
  gameId?: string | null | undefined;
  categoryId?: string | null | undefined;
  providerId?: string | null | undefined;
  excludeTournamentIds?: Array<string | null | undefined> | string | null | undefined;
  orderBy?: Types.CasinoTournamentsPublicTournamentsQueryOrderBy | null | undefined;
}>;


export type TournamentsQuery = { casinoTournamentsPublic: { __typename: 'CasinoTournamentsPublic', id: string | undefined, tournaments: { __typename: 'CasinoTournamentsPublicTournamentConnection', edges: Array<{ __typename: 'CasinoTournamentsPublicTournamentEdge', node: { __typename: 'CasinoTournamentsPublicTournament', id: string, enabled: boolean | undefined, openAt: any, closeAt: any, iAmOptedIn: boolean | undefined, name: string | undefined, prizeText: string | undefined, activityType: string | undefined, shortUrl: string | undefined, backgroundImageSmall: string | undefined, backgroundImageLarge: string | undefined, rules: string | undefined, leaderboardType: string | undefined, myScore: { id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined, leaderboardAfter: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined, leaderboardBefore: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined } | undefined, prizes: Array<{ id: string, forPosition: number | undefined, name: string | undefined, link: string | undefined, automaticallyReleased: boolean | undefined } | undefined> | undefined, leaderboard: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined } | undefined } | undefined> | undefined, pageInfo: { endCursor: string | undefined, hasNextPage: boolean } } | undefined } | undefined };


export const TournamentsQueryDocument = gql`
    query TournamentsQuery($site: String, $first: Int, $last: Int, $after: String, $before: String, $onlyCurrent: Boolean, $onlyFuture: Boolean, $onlyPast: Boolean, $onlyMy: Boolean, $onlyMyWithUnclaimedPrize: Boolean, $gameId: String, $categoryId: String, $providerId: String, $excludeTournamentIds: [String], $orderBy: CasinoTournamentsPublicTournamentsQueryOrderBy) {
  casinoTournamentsPublic {
    id
    tournaments(
      site: $site
      first: $first
      last: $last
      after: $after
      before: $before
      onlyCurrent: $onlyCurrent
      onlyFuture: $onlyFuture
      onlyPast: $onlyPast
      onlyMy: $onlyMy
      onlyMyWithUnclaimedPrize: $onlyMyWithUnclaimedPrize
      orderBy: $orderBy
      gameId: $gameId
      categoryId: $categoryId
      providerId: $providerId
      excludeTournamentIds: $excludeTournamentIds
    ) {
      edges {
        node {
          ...TournamentFragment
          __typename
        }
        __typename
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      __typename
    }
    __typename
  }
}
    ${TournamentFragmentDoc}`;